import { TLCLogger } from "../logger";
import { TLCEventHandler } from "./EventHandler";

class TLCEvent {

	payload = null;
	/**
	 *
	 * @type {Array.<string,string>|null}
	 */
	pathParams = null;

	/**
	 * @constructor
	 * @param {Object|null} payload
	 */
	constructor(payload, eventName) {
    Object.assign(this, payload);
		// $.extend(this, payload);
		this.eventName = eventName;
	}
}

export class TLCEvents {
  /**
   *
   * @type {Object.<string,TLCEventHandler>}
   * @private
   */
  static _methodHash = {};

  /**
   *
   * @type {number}
   * @private
   */
  static _guid = 0;

  /**
   * Event to fire
   * @param {string} handle
   * @param {*=} data
   * @expose
   */
  static trigger(handle, data) {
    if (arguments.length == 0) {
      return;
    }

    var event = new TLCEvent(data, handle);

    var eventHandler = TLCEvents._methodHash[handle];

    if (eventHandler) {
      var callbacks = eventHandler.callbacks;
      for (var i = 0, len = callbacks.length; i < len; i += 1) {
        var handler = callbacks[i];

        if (handler === undefined) {
          continue;
        }

        try {
          handler.callback.apply(handler.scope, [event]);

          if (handler.isOneTime) {
            delete TLCEvents._methodHash[handle].callbacks[i];
          }
        } catch (e) {
          TLCLogger.log(e);
        }
      }
    } else {
      TLCLogger.log(
        "EventManager says event: '" +
          handle +
          "' does not have a listener set up"
      );
    }
  }

  /**
   * Event to listen for just one time
   * @param {string} handle
   * @param {function()=} callback
   * @param {*=} scope the "this" which you want it to reference
   * @return {number}
   * @expose
   */
  static once(handle, callback, scope) {
    return TLCEvents.on(handle, callback, scope, true);
  }

  /**
   *
   * @param {string} handle
   * @param {*=} scope
   * @param {boolean=} isOneTime
   * @return {*}
   */
  static on(handle, callback, scope, isOneTime) {
    if (arguments.length < 2) {
      // tried to add handler with no callback
      return;
    } else if (arguments.length == 3) {
      if (typeof scope === "boolean") {
        isOneTime = scope ? false : true;
        scope = window;
      } else {
        isOneTime = false;
      }
    }

    TLCEvents._guid++;

    if (!TLCEvents._methodHash[handle]) {
      TLCEvents._methodHash[handle] = {
        callbacks: [],
      };
    }

    var handler = new TLCEventHandler({
      guid: TLCEvents._guid,
      callback: callback,
      isOneTime: isOneTime,
      scope: scope,
    });

    TLCEvents._methodHash[handle].callbacks.push(handler);

    return TLCEvents._guid;
  }

  /**
   *
   * @param {string} handle
   * @param {number} guid
   */
  static off(handle, guid) {
    var callbacks = TLCEvents._methodHash[handle].callbacks;

    for (var index = 0, len = callbacks.length; index < len; index += 1) {
      var item = callbacks[index];

      if (item !== undefined && item.guid == guid) {
        delete callbacks[index];
      }
    }
  }
}
